import React from 'react';
import { useLang } from '../context/LanguageContext';
import { socials } from '../data/mock';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A1A1A] text-[#FAF8F4] pt-20 pb-8">
      <div className="container-tight">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="display text-[36px] tracking-wide">DEVIL TATTOOZ</div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#D4B987] mt-3">{t.footer.tagline}</div>
            <p className="text-[14px] text-white/60 mt-6 max-w-md leading-[1.8]">
              {lang === 'fr'
                ? 'Une expérience luxueuse du piercing & tatouage, au coeur de Villiers-sur-Marne.'
                : 'A luxurious piercing & tattoo experience, in the heart of Villiers-sur-Marne.'}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.32em] uppercase text-[#D4B987] mb-5">{t.footer.quickLinks}</div>
            <ul className="space-y-3">
              {[
                { id: 'piercing', k: 'piercing' },
                { id: 'bijoux', k: 'bijoux' },
                { id: 'grillz', k: 'grillz' },
                { id: 'strass', k: 'strass' },
                { id: 'prothese-acier', k: 'protheseAcier' },
                { id: 'prothese-titane', k: 'protheseTitane' },
                { id: 'realisations', k: 'realisations' },
                { id: 'reviews', k: 'reviews' },
                { id: 'contact', k: 'contact' },
              ].map(({ id, k }) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="text-[14px] text-white/70 hover:text-[#D4B987] transition-colors capitalize">
                    {t.nav[k]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.32em] uppercase text-[#D4B987] mb-5">Contact</div>
            <p className="text-[14px] text-white/70 leading-[1.8]">17 Rue Louis Lenoir<br/>94350 Villiers-sur-Marne<br/>France</p>
            <div className="flex gap-3 mt-5">
              <a href={socials.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/20 hover:border-[#D4B987] hover:text-[#D4B987] flex items-center justify-center transition-colors">
                <Instagram size={16} />
              </a>
              <a href={socials.tiktok} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/20 hover:border-[#D4B987] hover:text-[#D4B987] flex items-center justify-center transition-colors text-[10px] tracking-widest">
                TT
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-[11px] text-white/40 tracking-wide">
            © {year} Devil Tattooz. {t.footer.rights}
          </div>
          <div className="flex gap-6 text-[11px] text-white/40 tracking-wide">
            <a href="#" className="hover:text-[#D4B987] transition-colors">{t.footer.legal}</a>
            <a href="#" className="hover:text-[#D4B987] transition-colors">{t.footer.privacy}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
